import React from "react";  
import styles from "./Main.module.css";  
  
const Main = ({children, userInfo, handleLogout, handleLogin, isBotVisible}) => {  
  return (  
    <div className={styles.home}>  
      <div className={styles.imageContainer}>  
        <img  
          src="/short_banner.png" // Replace with your image URL  
          alt="Full Screen"  
          className={styles.fullScreenImage}  
        />  
        <div className={styles.overlay}>  
          {userInfo ? (  
            <div>  
              <h3 style={{fontWeight: '400', marginTop: "7rem", fontSize: '2.1rem', lineHeight: "1em"}}>Bienvenido, {userInfo.name.split(" ")[0]}!</h3>
              <p className={`${styles.mainTitle}`} >SOY <b>BATA BOT</b>, ESTOY AQUÍ  <br/> PARA AYUDARTE </p>
              { !isBotVisible && <p className={`${styles.instructionSection}`}> <b> Cuéntame. <br/> ¿Qué preguntas tienes sobre el cambio de oficina?  </b> </p>}
              {children}
            </div>  
          ) : (  
            <div>  
              <p className={`${styles.mainTitle}`} >SOY <b>BATA BOT</b>, ESTOY AQUÍ  <br/> PARA AYUDARTE </p>
              <p className={`${styles.subTitle}`} >Por favor, inicia sesión para interactuar conmigo. </p>  
              <span className={" material-symbols-rounded " + styles.agentIcon} >support_agent</span> <br />
              <button className={styles.bataButton} onClick={handleLogin}>  
                Iniciar sesión con Microsoft
              </button>  
            </div>  
          )}  
        </div>  
      </div>  
    </div>  
  );  
};  
  
export default Main;  